import { Col, Row } from "antd";
import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import Form from "../../form-components/from";
import EndPoints from "../../../services/end-points";
import AppContext from "../../../context/app/context";
import OrderContext from "../../../context/order/context";
import { IStore } from "../../../models/store/response";
import { getOrderStatus, getOrderStyle } from "../../../models/order/enum";
import { useLocation } from "react-router-dom";
import { addSearchToURL, filtersToQueryString, getFiltersFromURL, getKeywordFromURL } from "../../../utils/helpers/url";
import { createActiveStoreFilter } from "../../../utils/helpers/store-filters";

interface IProps { }

const DATE_FORMAT = "YYYY-MM-DD";

const OrderFilter: React.FC<IProps> = () => {
    const { t } = useTranslation();
    const { actions, query } = useContext(OrderContext);

    const [client, setClient] = useState<any[]>([]);
    const [loadingClient, setLoadingClient] = useState(true);

    const [driver, setDriver] = useState<any[]>([]);
    const [loadingDriver, setLoadingDriver] = useState(true);

    const [store, setSorte] = useState<IStore[]>([]);
    const [loadingStore, setLoadingStore] = useState(true);

    const [paymentConfirmingUsers, setPaymentConfirmingUsers] = useState<any[]>([]);
    const [loadingPaymentConfirmingUsers, setLoadingPaymentConfirmingUsers] = useState(true);

    const { direction } = useContext(AppContext);
    const location = useLocation();
    const [initialValues, setInitialValues] = useState<Record<string, any>>({});

    useEffect(() => {
        const filters = getFiltersFromURL();

        const initialValuesObj = {};
        filters.forEach((f) => {
            initialValuesObj[f.name] = f.value;
        });

        setInitialValues(initialValuesObj);
    }, [location.search]);
    useEffect(() => {
        const getClient = async () => {
            try {
                const { data } = await EndPoints.client.getAllClient({
                    light: true,
                    perPage: -1,
                });
                setClient(data.data);
                setLoadingClient(false);
            } catch (error) {
            } finally {
                setLoadingClient(false);
            }
        };
        getClient();
    }, [direction]);

    useEffect(() => {
        const getDriver = async () => {
            try {
                const { data } = await EndPoints.deliveryWorkers.getAllDeliveryWorkers({
                    light: true,
                    perPage: -1,
                });
                setDriver(data.data);
                setLoadingDriver(false);
            } catch (error) {
            } finally {
                setLoadingDriver(false);
            }
        };
        getDriver();
    }, [direction]);

    useEffect(() => {
        const getStore = async () => {
            try {
                const { data } = await EndPoints.store.getAllStores({
                    light: true,
                    perPage: -1,
                    filters: [createActiveStoreFilter()],
                });
                setSorte(data.data);
                setLoadingStore(false);
            } catch (error) {
            } finally {
                setLoadingStore(false);
            }
        };
        getStore();
    }, [direction]);

    useEffect(() => {
        const getPaymentConfirmingUsers = async () => {
            try {
                const { data } = await EndPoints.order.getPaymentConfirmingUsers({
                    perPage: -1,
                });
                setPaymentConfirmingUsers(data.data);
                setLoadingPaymentConfirmingUsers(false);
            } catch (error) {
            } finally {
                setLoadingPaymentConfirmingUsers(false);
            }
        };
        getPaymentConfirmingUsers();
    }, [direction]);

    const status = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15]
    const types = [1, 2]
    const satisfactionStatuses = [
        "satisfied",
        "unsatisfied",
        "no_response",
        "undefined",
    ];

    return (
        <Form
            formId="order-filter"
            defaultValues={initialValues}
            onSubmit={(data) => {
                const keyword = getKeywordFromURL();
                const filter: any = {
                    page: INITIAL_PAGE,
                    perPage: query?.perPage,
                    keyword: keyword,
                    filters: [
                        data?.clientId
                            ? {
                                name: "clientId",
                                value: data.clientId,
                                operation: "eq",
                            }
                            : undefined,
                        data?.workerId
                            ? {
                                name: "workerId",
                                value: data.workerId,
                                operation: "eq",
                            }
                            : undefined,
                        data?.storeId
                            ? {
                                name: "storeId",
                                value: data.storeId,
                                operation: "eq",
                            }
                            : undefined,
                        data?.type
                            ? {
                                name: "type",
                                value: data.type,
                                operation: "eq",
                            }
                            : undefined,
                        data?.status
                            ? {
                                name: "status",
                                value: data.status,
                                operation: "eq",
                            }
                            : undefined,
                        data?.customerSatisfactionStatus
                            ? {
                                name: "customerSatisfactionStatus",
                                value: data.customerSatisfactionStatus,
                                operation: "eq",
                            }
                            : undefined,
                        data?.isEmergency
                            ? {
                                name: "isEmergency",
                                value: data.isEmergency,
                                operation: "eq",
                            }
                            : undefined,
                        data?.isExpressDelivery
                            ? {
                                name: "isExpressDelivery",
                                value: data.isExpressDelivery,
                                operation: "eq",
                            }
                            : undefined,
                        data?.paymentReceivedBy
                            ? {
                                name: "paymentReceivedBy",
                                value: data.paymentReceivedBy,
                                operation: "eq",
                            }
                            : undefined,
                        data?.isPaymentReceived !== undefined && data?.isPaymentReceived !== ""
                            ? {
                                name: "isPaymentReceived",
                                value: data.isPaymentReceived,
                                operation: "eq",
                            }
                            : undefined,
                        data?.createdFrom
                            ? {
                                name: "createdFrom",
                                value: data.createdFrom,
                                operation: "eq",
                            }
                            : undefined,
                        data?.createdTo
                            ? {
                                name: "createdTo",
                                value: data.createdTo,
                                operation: "eq",
                            }
                            : undefined,
                    ].filter((f) => f),
                };
                const queryString = filtersToQueryString(filter.filters);
                window.history.replaceState(null, "", `?${queryString}`);
                addSearchToURL(keyword);
                actions.setQuery(filter);
            }}
        >
            <Row justify={"start"} gutter={[10, 0]}>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="clientId"
                        label={`${t("client")}`}
                        width="large"
                        input={{
                            type: "select",
                            loading: loadingClient,
                            allowSearch: true,
                            options: client.map((client, index) => {
                                return {
                                    label: client.firstName,
                                    value: client.id as number,
                                };
                            }),
                        }}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="workerId"
                        label={`${t("delivery_worker")}`}
                        width="large"
                        input={{
                            type: "select",
                            allowSearch: true,
                            loading: loadingDriver,
                            options: driver.map((driver, index) => {
                                return {
                                    label: driver.firstName + ' ' + driver.lastName,
                                    value: driver.id as number,
                                };
                            }),
                        }}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="storeId"
                        label={`${t("store")}`}
                        width="large"
                        input={{
                            type: "select",
                            allowSearch: true,
                            loading: loadingStore,
                            options: store.map((store, index) => {
                                return {
                                    label: store.name,
                                    value: store.id as number,
                                };
                            }),
                        }}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="status"
                        label={`${t("status")}`}
                        width="large"
                        input={{
                            type: "select",
                            options: status.map((status, index) => {
                                return {
                                    label: t(getOrderStatus(status) as string),
                                    value: status as number,
                                };
                            }),
                        }}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="type"
                        label={`${t("request_sourse_type")}`}
                        width="large"
                        input={{
                            type: "select",
                            options: types?.map((type, index) => {
                                return {
                                    label: t(getOrderStyle(type)),
                                    value: type as number,
                                };
                            }),
                        }}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="customerSatisfactionStatus"
                        label={`${t("customer_satisfaction_status")}`}
                        width="large"
                        input={{
                            type: "select",
                            options: satisfactionStatuses.map((status) => {
                                return {
                                    label: t(status === "undefined" ? "not_determined" : status),
                                    value: status,
                                };
                            }),
                        }}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="isEmergency"
                        label={`${t("emergency")}`}
                        width="large"
                        input={{
                            type: "select",
                            options: [1, 2].map((cat, index) => {
                                return {
                                    label: index == 0 ? t("yes") : t("no"),
                                    value: index == 0 ? 1 : "0",
                                };
                            }),
                        }}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="isExpressDelivery"
                        label={`${t("is_express_delivery")}`}
                        width="large"
                        input={{
                            type: "select",
                            options: [1, 2].map((cat, index) => {
                                return {
                                    label: index == 0 ? t("express_order") : t("normal_order"),
                                    value: index == 0 ? 1 : "0",
                                };
                            }),
                        }}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="paymentReceivedBy"
                        label={`${t("payment_received_by_accountant")}`}
                        width="large"
                        input={{
                            type: "select",
                            allowSearch: true,
                            loading: loadingPaymentConfirmingUsers,
                            options: paymentConfirmingUsers.map((user) => {
                                return {
                                    label: user.fullName || `${user.firstName} ${user.lastName}`,
                                    value: user.id as number,
                                };
                            }),
                        }}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="isPaymentReceived"
                        label={`${t("payment_received_status")}`}
                        width="large"
                        input={{
                            type: "select",
                            options: [
                                { label: t("all"), value: "" },
                                { label: t("payment_received"), value: 1 },
                                { label: t("payment_not_received"), value: 0 },
                            ],
                        }}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="createdFrom"
                        label={`${t("created_from")}`}
                        width="large"
                        input={{
                            type: "date-picker",
                            format: DATE_FORMAT,
                            showTime: false,
                        }}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="createdTo"
                        label={`${t("created_to")}`}
                        width="large"
                        input={{
                            type: "date-picker",
                            format: DATE_FORMAT,
                            showTime: false,
                        }}
                    />
                </Col>
            </Row>
        </Form>
    );
};

export default OrderFilter;
